import { Component } from '@angular/core';

@Component({
  selector: 'icon-instagram',
  templateUrl: './icon-instagram.component.html',
  styles: []
})
export class IconInstagramComponent {}
